<div class="row align-items-center center-div">
     <div class="col text-center">
          <img src="./assets/logo/rovuck.png" alt="rovuk" width="40%" height="40%" />
     </div>
     <div class="col text-center">
          <img src="./assets/logo/rightarrow.png" alt="arrow" width="50%" height="50%" />
     </div>
     <div class="col text-center">
          <img src="./assets/logo/smartaccupay_logo.png" alt="smartaccupay" width="30%" height="30%" />
     </div>
</div>